ACC.cartitem = {
    _autoload: ["bindCartItem"],

    submitTriggered: false,

    bindCartItem: function () {
        $(".js-remove-entry-button").on("click", function () {
            var entryNumber = $(this).attr("id").split("_");

            $(".js-remove-entry-button").find("a:first").removeAttr("href");
            $(".js-remove-entry-button").unbind("click");
            var form = $("#updateCartForm" + entryNumber[1]);

            var productCode = form.find("input[name=productCode]").val();

            var initialCartQuantity = form.find("input[name=initialQuantity]").val();
            var cartQuantity = form.find("input[name=quantity]").val();
            var withMkpCertificate = form.find("input[name=withMkpCertificate]");
            var mkpCertificateEntryNumber = form.find("input[name=mkpCertificateEntryNumber]");

            var ObjToTrack = {"productCode":productCode , "initialCartQuantity" : initialCartQuantity , "productName" : form.data("cart").productName,
                "productCat1" : form.find("input[name=productCat]").val() , "productCat2" : form.find("input[name=productCat2]").val() ,
                "productPrice" : form.data("cart").productPostPrice , "cartPrice" : form.data("cart").cartPrice , "productStock" : form.find("input[name=productStock]").val() , "affiliation" : form.find("input[name=affiliation]").val() !== '' ? form.find("input[name=affiliation]").val() !== '' : undefined};
            ACC.track.trackRemoveFromCart(ObjToTrack);

            form.find("input[name=quantity]").val(0);
            form.find("input[name=initialQuantity]").val(0);

            form.submit();
        });

        $(".js-update-entry-quantity-input")
            .on("blur", function (e) {
                ACC.cartitem.handleUpdateQuantity(this, e);
            })
            .on("keyup", function (e) {
                return ACC.cartitem.handleKeyEvent(this, e);
            })
            .on("keydown", function (e) {
                return ACC.cartitem.handleKeyEvent(this, e);
            });

        $(".js-mkpCheckCertif_item").change(function() {

            var isChecked = this.checked;
            var certificateCode = this.getAttribute('data-mkp-certificate-code');
            var entryNumber = this.getAttribute('data-entryNumber');
            var certifiedMKPProduct = this.getAttribute('data-offer-id');

            if (isChecked) {
                $.postJSON(ACC.config.addMkpCertificate, {
                    withMkpCertificate: true,
                    mkpCertificateCode: certificateCode,
                    entryNumber: entryNumber,
                    certifiedMKPProduct: certifiedMKPProduct
                }, function (data) {
                    if (data) {
                        location.reload();
                    }
                });
            } else {
                $.postJSON(ACC.config.deleteMkpCertificate, {
                    withMkpCertificate: false,
                    mkpCertificateCode: certificateCode,
                    entryNumber: entryNumber,
                    certifiedMKPProduct:certifiedMKPProduct
                }, function (data) {
                    if (data) {
                        location.reload();
                    }
                });
            }
        });
    },

    handleKeyEvent: function (elementRef, event) {
        //console.log("key event (type|value): " + event.type + "|" + event.which);

        if (event.which == 13 && !ACC.cartitem.submitTriggered) {
            ACC.cartitem.submitTriggered = ACC.cartitem.handleUpdateQuantity(
                elementRef,
                event
            );
            return false;
        } else {
            // Ignore all key events once submit was triggered
            if (ACC.cartitem.submitTriggered) {
                return false;
            }
        }

        return true;
    },

    handleUpdateQuantity: function (elementRef, event) {
        var form = $(elementRef).closest("form");

        var productCode = form.find("input[name=productCode]").val();
        var initialCartQuantity = form.find("input[name=initialQuantity]").val();
        var newCartQuantity = parseInt(form.find("input[name=quantity]").val());
        var mkpOfferMinOrderQuantity = parseInt(
            form.find("input[name=quantity]").attr("data-min-order")
        );
        if (initialCartQuantity != newCartQuantity && newCartQuantity !== "") {
            if (
                mkpOfferMinOrderQuantity !== NaN &&
                mkpOfferMinOrderQuantity !== 0 &&
                newCartQuantity < mkpOfferMinOrderQuantity
            ) {
                form
                    .closest(".wrapper-product-name")
                    .find(".msg-min-order")
                    .removeClass("hidden");
                $(".btn--continue-checkout").prop("disabled", true);

                form.find("input[name=quantity]").addClass('min-order');
            } else {
                form
                    .closest(".wrapper-product-name")
                    .find(".msg-min-order")
                    .addClass("hidden");
                form.find("input[name=quantity]").removeClass('min-order');
                ACC.track.trackUpdateCart(
                    productCode,
                    initialCartQuantity,
                    newCartQuantity
                );
                if (!isNaN(newCartQuantity)) {
                    $('.clear-cart').attr('href', '#');
                    form.submit();
                }

                return true;
            }
        }

        return false;
    }
};
